import type { MatchStanding } from './types.js';

/**
 * Seats of the team ranked best by `sign` (+1 = highest wins, -1 = lowest
 * wins). A team is ranked by its best seat's score, mirroring the per-seat
 * match-over check. Ties prefer the team that won the last hand, then the
 * lowest team index.
 */
export function bestTeamSeats(standing: MatchStanding, sign: 1 | -1): readonly number[] {
  const { scores, teamMap, lastResult } = standing;
  const teamScore = new Array<number>(teamMap.teamCount).fill(-Infinity * sign);
  for (let seat = 0; seat < teamMap.teamOf.length; seat += 1) {
    const team = teamMap.teamOf[seat] ?? seat;
    const score = scores[seat] ?? 0;
    const current = teamScore[team] ?? -Infinity * sign;
    teamScore[team] = sign > 0 ? Math.max(current, score) : Math.min(current, score);
  }
  let bestTeam = 0;
  for (let t = 1; t < teamMap.teamCount; t += 1) {
    if (((teamScore[t] ?? 0) - (teamScore[bestTeam] ?? 0)) * sign > 0) bestTeam = t;
  }
  const lastWinner = lastResult?.winnerSeats[0];
  if (lastWinner !== undefined) {
    const lastTeam = teamMap.teamOf[lastWinner] ?? lastWinner;
    if (teamScore[lastTeam] === teamScore[bestTeam]) bestTeam = lastTeam;
  }
  const seats: number[] = [];
  for (let seat = 0; seat < teamMap.teamOf.length; seat += 1) {
    if ((teamMap.teamOf[seat] ?? seat) === bestTeam) seats.push(seat);
  }
  return seats;
}
